import React from 'react';

import {assertAndContinue} from 'Asserts';
import {Header1} from 'ui-library/Headers';
import {assertNever} from 'util/Types';

import {DataLayoutSection as DataLayoutSectionType} from './DataLayoutTypes';
import GridSection from './GridSection';
import TabSection from './TabSection';

interface DataLayoutSectionProps {
  layoutPath: Array<string | number>;
  section: DataLayoutSectionType;
}

/** @package */
export default function DataLayoutSection({layoutPath, section}: DataLayoutSectionProps): JSX.Element {
  let sectionContents;
  if (section.type === 'GRID') {
    sectionContents = <GridSection grid={section.grid} layoutPath={layoutPath} />;
  } else if (section.type === 'TAB') {
    sectionContents = <TabSection tabSection={section} layoutPath={layoutPath} />;
  } else {
    assertAndContinue(false, 'Found unexpected section type in layout', {
      sectionType: assertNever(section).type,
    });
    sectionContents = null;
  }
  return (
    <>
      {section.title && <Header1>{section.title}</Header1>}
      {sectionContents}
    </>
  );
}
